
import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, Upload, Button, message } from "antd";
import { CloudUploadOutlined, UploadOutlined, ArrowRightOutlined } from "@ant-design/icons";

import { BreadcrumbAbrirChamado } from "../../components";

export default function RetornoBancario() {

    const props = {
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
            console.log(info.file, info.fileList);
            }
            if (status === 'done') {
            message.success(`${info.file.name} carregado com sucesso.`);
            } else if (status === 'error') {
            message.error(`${info.file.name} o upload deste arquivo falhou.`);
            }
        },
        defaultFileList: [
            {
                uid: '1',
                name: 'gestao_e_modulos.pdf',
                status: 'done',
            },
            {
                uid: '2',
                name: 'gestao.pdf',
                status: 'done',
            },
            {
                uid: '3',
                name: 'modulos.pdf',
                status: 'done',
            },
        ]
    };

    return (
        <div className="p-10">
            <BreadcrumbAbrirChamado />
            <Row align="middle">
                <Col span={24}>
                    <div className="upload">
                        <Upload.Dragger {...props}>
                            <Row align="middle" justify="center" gutter={[0, 8]}>
                                <Col>
                                    <p className="ant-upload-drag-icon m-0">
                                        <CloudUploadOutlined />
                                    </p>
                                    <p className="ant-upload-text">
                                        Arraste o Arquivo de Retorno aqui!
                                    </p>
                                </Col>
                            </Row>
                            <Row align="middle" justify="center" gutter={[0, 8]}>
                                <Col>
                                    <Button type="primary" icon={<UploadOutlined />}>
                                        Importar Arquivo
                                    </Button>
                                </Col>
                            </Row>
                        </Upload.Dragger>
                    </div> 
                </Col>
            </Row>          
            <Row align="middle" justify="end" className="m-t-16">
                <Col>
                    <Link to="/retornoBancarioLista/">
                        <Button type="primary" size="large">
                            Avançar <ArrowRightOutlined />
                        </Button>
                    </Link>
                </Col>
            </Row>
        </div>
    );
    
}